<div *transloco="let t" class="business-root">
  <div class="business-list-title-container">
    <app-header [hasDashedLine]="false">{{ t('business-list') }}</app-header>
    <app-region-selector></app-region-selector>
  </div>
  <div class="dashed-line"></div>
  <div class="filter-container">
    <div class="left-filters">
      <app-filter-container
        class="left-selectors"
        (selectFilterClick)="updateFilter($event)"
        [baseSimpleChipData]="chipContents"
        [filters]="this.filters"
        [statusChips]="this.statusChips"
        [seriesChips]="this.seriesChips"
        *ngIf="showFilter"
      ></app-filter-container>
    </div>
    <div class="right-filters">
      <app-country-selector
        class="country-selector"
        [countries]="countriesFromRegion"
        (valueChange)="onCountryFilterChanged($event)">
      </app-country-selector>
      <div class="search">
        <app-input
          id="search-business-input"
          [placeholder]="t('business-search')"
          [type]="'search'"
          [control]="search"
          (searchClick)="getBusinesses(true)"
          *ngIf="showFilter"
        >
        </app-input>
      </div>
    </div>

  </div>
  <div
    class="businesses-list"
    *ngIf="feedItems.length"
    infinite-scroll
    [infiniteScrollDistance]="0.1"
    [scrollWindow]="false"
    [immediateCheck]="true"
    (scrolled)="getBusinesses(false)"
  >
    <div *ngFor="let item of feedItems">
      <app-business-card [business]="item"></app-business-card>
    </div>
  </div>
  <div class="loading-more-items">
    <mat-spinner diameter="40" *ngIf="loading"></mat-spinner>
  </div>
  <div *ngIf="feedItems && !feedItems.length && !loading" class="empty">
    <app-empty-feed
      icon="list_alt"
      header="{{ t('empty-business') }}"
      text="{{ t('feed-not-listed-description') }}"
    >
    </app-empty-feed>
  </div>
</div>
